"use strict";
/* eslint-disable */
/* This file is auto-generated by packages/message-schemas/scripts/generate.ts — do not edit */
Object.defineProperty(exports, "__esModule", { value: true });
exports.transcriptTurnEventSchema = void 0;
const zod_1 = require("zod");
exports.transcriptTurnEventSchema = zod_1.z
    .object({
    sessionId: zod_1.z.string().describe('Interview session UUID'),
    speaker: zod_1.z.enum(['SARA', 'CANDIDATE']).describe('Who spoke this turn'),
    content: zod_1.z.string().describe('Full transcript text of the turn'),
    turnIndex: zod_1.z.number().int().gte(0).describe('Zero-based turn counter for the session'),
    phase: zod_1.z
        .enum([
        'greeting',
        'musical_interlude',
        'experience',
        'situational',
        'availability',
        'closing',
    ])
        .describe('Current interview phase'),
    interrupted: zod_1.z.boolean().describe('Whether the speaker was interrupted'),
    transcriptConfidence: zod_1.z
        .union([
        zod_1.z.number().describe('STT confidence score (0-1)'),
        zod_1.z.null().describe('STT confidence score (0-1)'),
    ])
        .describe('STT confidence score (0-1)')
        .optional(),
    startedSpeakingAt: zod_1.z
        .union([
        zod_1.z.number().describe('Unix timestamp when the speaker started'),
        zod_1.z.null().describe('Unix timestamp when the speaker started'),
    ])
        .describe('Unix timestamp when the speaker started')
        .optional(),
    stoppedSpeakingAt: zod_1.z
        .union([
        zod_1.z.number().describe('Unix timestamp when the speaker stopped'),
        zod_1.z.null().describe('Unix timestamp when the speaker stopped'),
    ])
        .describe('Unix timestamp when the speaker stopped')
        .optional(),
    e2eLatencySec: zod_1.z
        .union([
        zod_1.z.number().describe('End-to-end latency in seconds'),
        zod_1.z.null().describe('End-to-end latency in seconds'),
    ])
        .describe('End-to-end latency in seconds')
        .optional(),
    llmTtftSec: zod_1.z
        .union([
        zod_1.z.number().describe('LLM time-to-first-token in seconds'),
        zod_1.z.null().describe('LLM time-to-first-token in seconds'),
    ])
        .describe('LLM time-to-first-token in seconds')
        .optional(),
    transcriptionDelaySec: zod_1.z
        .union([
        zod_1.z.number().describe('STT transcription delay in seconds'),
        zod_1.z.null().describe('STT transcription delay in seconds'),
    ])
        .describe('STT transcription delay in seconds')
        .optional(),
    endOfTurnDelaySec: zod_1.z
        .union([
        zod_1.z.number().describe('Delay between end of speech and turn completion in seconds'),
        zod_1.z.null().describe('Delay between end of speech and turn completion in seconds'),
    ])
        .describe('Delay between end of speech and turn completion in seconds')
        .optional(),
})
    .strict()
    .describe('A single turn in an interview transcript, published by the agent to the API.');
